import { usePermissions } from './usePermissions';
import { useAuth } from '../context/AuthContext';

/**
 * Hook لاستخدام صلاحيات نقاط الولاء
 */
export const useLoyaltyPermissions = () => {
  const { hasPermission } = usePermissions();
  const { user } = useAuth();
  const isAdmin = user?.isSystemAdmin || false;

  return {
    // صلاحية الوصول للصفحة
    canViewLoyaltyPage: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'view_page');
    },

    // اعداد نقاط الولاء
    canSetupLoyalty: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'setup');
    },

    // معالجة النقاط يدويا
    canManualProcess: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'manual_process');
    },

    // حذف جميع النقاط
    canDeleteAll: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'delete_all');
    },

    // تعديل
    canEdit: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'edit');
    },

    // جدولة تلقائية
    canAutoSchedule: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'auto_schedule');
    },

    // الغاء تفعيل
    canDeactivate: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'deactivate');
    },

    // حذف
    canDelete: () => {
      return isAdmin || hasPermission('contacts', 'loyalty-points', 'delete');
    },

    // دالة مساعدة للتحقق من أي صلاحية
    hasAnyLoyaltyPermission: () => {
      return isAdmin ||
             hasPermission('contacts', 'loyalty-points', 'view_page') ||
             hasPermission('contacts', 'loyalty-points', 'setup') ||
             hasPermission('contacts', 'loyalty-points', 'manual_process') ||
             hasPermission('contacts', 'loyalty-points', 'delete_all') ||
             hasPermission('contacts', 'loyalty-points', 'edit') ||
             hasPermission('contacts', 'loyalty-points', 'auto_schedule') ||
             hasPermission('contacts', 'loyalty-points', 'deactivate') ||
             hasPermission('contacts', 'loyalty-points', 'delete');
    }
  };
};